import { defineAppConfig } from '@zto/zpage'
import { META_APP_NAMES } from '../consts'

import type { App, AppMicroConfig } from '@zto/zpage'

/** 微应用配置 */
export default defineAppConfig<AppMicroConfig>((app: App) => {
  const { appEntries } = app.env

  return {
    apps: []
  }
})
